var _g, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _path, _line, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path9, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _g2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _rect55, _rect56, _rect57, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDefaultPreview = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 586,
    height: 386,
    viewBox: "0 0 586 386",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_817_4938)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5,
    width: 576,
    height: 376,
    rx: 10,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 138.465)",
    fill: "#B4B2B2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 138.465)",
    fill: "#B4B2B2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 138.465)",
    fill: "#B4B2B2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 177.895)",
    fill: "#B4B2B2"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 177.895)",
    fill: "#B4B2B2"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 177.895)",
    fill: "#B4B2B2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 217.32)",
    fill: "#B4B2B2"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 217.32)",
    fill: "#B4B2B2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 217.32)",
    fill: "#B4B2B2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 256.75)",
    fill: "#B4B2B2"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 256.75)",
    fill: "#B4B2B2"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 256.75)",
    fill: "#B4B2B2"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 296.18)",
    fill: "#B4B2B2"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 296.18)",
    fill: "#B4B2B2"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 296.18)",
    fill: "#B4B2B2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 335.605)",
    fill: "#B4B2B2"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 335.605)",
    fill: "#B4B2B2"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 14.1125,
    rx: 1.83817,
    transform: "matrix(1.19249e-08 -1 -1 -1.19249e-08 48.7578 335.605)",
    fill: "#B4B2B2"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 230.547 346.676)",
    fill: "#B4B2B2"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 230.547 346.676)",
    fill: "#B4B2B2"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 230.547 346.676)",
    fill: "#B4B2B2"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 326.547 346.676)",
    fill: "#B4B2B2"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 326.547 346.676)",
    fill: "#B4B2B2"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 326.547 346.676)",
    fill: "#B4B2B2"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 423.402 346.676)",
    fill: "#B4B2B2"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 423.402 346.676)",
    fill: "#B4B2B2"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 423.402 346.676)",
    fill: "#B4B2B2"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 520.262 346.676)",
    fill: "#B4B2B2"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 520.262 346.676)",
    fill: "#B4B2B2"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 520.262 346.676)",
    fill: "#B4B2B2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56 333.643L550 333.643",
    stroke: "black",
    strokeOpacity: 0.12
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 294.5,
    x2: 550,
    y2: 294.5,
    stroke: "black",
    strokeOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M56 255.285L88.5714 255.285",
    stroke: "black",
    strokeOpacity: 0.12
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M115.113 255.293L121.97 255.293",
    stroke: "black",
    strokeOpacity: 0.12
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M149.429 255.285L184.571 255.285",
    stroke: "black",
    strokeOpacity: 0.12
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.97 255.293L218.827 255.293",
    stroke: "black",
    strokeOpacity: 0.12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M223.97 255.293L377.398 255.293",
    stroke: "black",
    strokeOpacity: 0.12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M550 255.293L404.827 255.293",
    stroke: "black",
    strokeOpacity: 0.12
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M56 215.428L121.571 215.428",
    stroke: "black",
    strokeOpacity: 0.12
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 149.429,
    y1: 215.357,
    x2: 218.857,
    y2: 215.357,
    stroke: "black",
    strokeOpacity: 0.12
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 246.286,
    y1: 215.357,
    x2: 315.714,
    y2: 215.357,
    stroke: "black",
    strokeOpacity: 0.12
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 343.143,
    y1: 215.357,
    x2: 413.429,
    y2: 215.357,
    stroke: "black",
    strokeOpacity: 0.12
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 439.113,
    y1: 215.363,
    x2: 518.827,
    y2: 215.363,
    stroke: "black",
    strokeOpacity: 0.12
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 536,
    y1: 215.5,
    x2: 551,
    y2: 215.5,
    stroke: "black",
    strokeOpacity: 0.12
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 535,
    y1: 175.5,
    x2: 551,
    y2: 175.5,
    stroke: "black",
    strokeOpacity: 0.12
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 175.928,
    x2: 507.714,
    y2: 175.928,
    stroke: "black",
    strokeOpacity: 0.12
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56 136.5L550 136.5",
    stroke: "black",
    strokeOpacity: 0.12
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 218.028,
    y: 186.141,
    width: 27.4286,
    height: 148.286,
    fill: "#5856AD"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 218.028,
    y: 228.369,
    width: 27.4286,
    height: 106.059,
    fill: "#1B2473"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 183.742,
    y: 229.352,
    width: 27.4286,
    height: 105.077,
    fill: "#D66F75"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 183.742,
    y: 258.812,
    width: 27.4286,
    height: 75.6159,
    fill: "#CE5269"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 121.204,
    y: 185.832,
    width: 27.4286,
    height: 148.286,
    fill: "#5856AD"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 121.204,
    y: 228.061,
    width: 27.4286,
    height: 106.059,
    fill: "#1B2473"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 86.918,
    y: 229.041,
    width: 27.4286,
    height: 105.077,
    fill: "#D66F75"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 86.918,
    y: 258.502,
    width: 27.4286,
    height: 75.6159,
    fill: "#CE5269"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 314.896,
    y: 177.723,
    width: 27.4286,
    height: 156,
    fill: "#5856AD"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 314.896,
    y: 222.148,
    width: 27.4286,
    height: 111.576,
    fill: "#1B2473"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 280.609,
    y: 223.18,
    width: 27.4286,
    height: 110.543,
    fill: "#D66F75"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 280.609,
    y: 254.174,
    width: 27.4286,
    height: 79.5496,
    fill: "#CE5269"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 411.775,
    y: 185.895,
    width: 27.4286,
    height: 148.286,
    fill: "#5856AD"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 411.775,
    y: 228.123,
    width: 27.4286,
    height: 106.059,
    fill: "#1B2473"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 377.488,
    y: 229.102,
    width: 27.4286,
    height: 105.077,
    fill: "#D66F75"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 377.488,
    y: 258.562,
    width: 27.4286,
    height: 75.6158,
    fill: "#CE5269"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 507.733,
    y: 164.928,
    width: 27.4286,
    height: 168.857,
    fill: "#ACAAD6"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 474.305,
    y: 218.834,
    width: 27.4286,
    height: 114.95,
    fill: "#EBB7BA"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 507.733,
    y: 206.152,
    width: 27.4286,
    height: 127.634,
    fill: "#1B2473"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 474.305,
    y: 248.17,
    width: 27.4286,
    height: 85.6177,
    fill: "#CE5269"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_817_4938",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 474,
    y: 164,
    width: 62,
    height: 170
  }, _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 507.735,
    y: 164.926,
    width: 27.4286,
    height: 168.857,
    fill: "#ACAAD6"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 474.306,
    y: 218.832,
    width: 27.4286,
    height: 114.95,
    fill: "#EBB7BA"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 507.735,
    y: 206.15,
    width: 27.4286,
    height: 127.634,
    fill: "#1B2473"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 474.306,
    y: 248.168,
    width: 27.4286,
    height: 85.6177,
    fill: "#CE5269"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_817_4938)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 362.018 202.822)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 364.376 201.564)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 366.733 200.305)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 369.09 199.049)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 371.447 197.791)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 373.804 196.531)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 376.161 195.273)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 378.515 194.014)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 380.872 192.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 383.229 191.5)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 385.587 190.236)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 387.944 188.982)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 390.301 187.723)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 392.658 186.463)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 395.015 185.205)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 397.372 183.945)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 399.729 182.688)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 402.087 181.428)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 404.444 180.17)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 406.801 178.91)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 409.158 177.654)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 411.515 176.396)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 413.872 175.137)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 416.226 173.877)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 418.583 172.619)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 420.94 171.359)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 423.297 170.102)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 425.655 168.846)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 428.012 167.586)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 430.369 166.328)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 432.726 165.068)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 435.083 163.811)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 437.44 162.551)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 439.797 161.291)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 442.155 160.033)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 444.512 158.773)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 446.869 157.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 449.226 156.256)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 451.58 154.998)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 453.937 153.742)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 456.294 152.482)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 458.651 151.225)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 461.008 149.965)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 463.366 148.705)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 465.723 147.447)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 468.08 146.191)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 470.437 144.93)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 472.794 143.674)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 475.151 142.414)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 477.508 141.156)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 479.866 139.896)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 482.223 138.639)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 484.576 137.379)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 486.937 136.119)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 489.291 134.861)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 491.648 133.602)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 494.005 132.346)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 496.362 131.088)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 498.719 129.828)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 501.076 128.57)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 503.434 127.311)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 505.791 126.053)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 508.148 124.793)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 510.505 123.533)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 512.862 122.275)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 515.219 121.02)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 517.576 119.76)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 519.934 118.502)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 522.287 117.242)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 524.645 115.984)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 527.002 114.725)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 529.359 113.467)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 0.841508,
    height: 238.986,
    transform: "matrix(0.882115 -0.471033 0.529536 0.848287 531.716 112.207)",
    fill: "white"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M545.95 90.75H547.05V91.85H545.95V90.75ZM545.95 92.95H547.05V96.25H545.95V92.95ZM546.5 88C543.464 88 541 90.464 541 93.5C541 96.536 543.464 99 546.5 99C549.536 99 552 96.536 552 93.5C552 90.464 549.536 88 546.5 88ZM546.5 97.9C544.075 97.9 542.1 95.9255 542.1 93.5C542.1 91.0745 544.075 89.1 546.5 89.1C548.926 89.1 550.9 91.0745 550.9 93.5C550.9 95.9255 548.926 97.9 546.5 97.9Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M461.481 67.17C461.481 66.5567 461.264 66.04 460.829 65.62C460.401 65.2 459.676 64.82 458.653 64.48C457.229 64.0467 456.19 63.4833 455.534 62.79C454.886 62.09 454.562 61.2033 454.562 60.13C454.562 59.0367 454.879 58.14 455.514 57.44C456.156 56.74 457.035 56.3233 458.152 56.19V54L459.646 54V56.2C460.769 56.3533 461.642 56.8233 462.263 57.61C462.892 58.3967 463.206 59.4733 463.206 60.84H461.361C461.361 59.9 461.137 59.1533 460.689 58.6C460.241 58.0467 459.636 57.77 458.874 57.77C458.078 57.77 457.47 57.9767 457.049 58.39C456.627 58.7967 456.417 59.3667 456.417 60.1C456.417 60.78 456.637 61.3233 457.079 61.73C457.527 62.13 458.259 62.4967 459.275 62.83C460.298 63.1567 461.093 63.52 461.662 63.92C462.237 64.3133 462.658 64.7733 462.925 65.3C463.199 65.8267 463.336 66.4433 463.336 67.15C463.336 68.2767 462.996 69.1833 462.314 69.87C461.638 70.5567 460.689 70.9633 459.465 71.09V73H457.981V71.09C456.738 70.9767 455.762 70.5367 455.053 69.77C454.351 68.9967 454 67.95 454 66.63H455.855C455.855 67.5567 456.099 68.27 456.587 68.77C457.075 69.27 457.767 69.52 458.663 69.52C459.539 69.52 460.228 69.31 460.729 68.89C461.231 68.47 461.481 67.8967 461.481 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M473.014 67.17C473.014 66.5567 472.797 66.04 472.362 65.62C471.934 65.2 471.209 64.82 470.186 64.48C468.762 64.0467 467.722 63.4833 467.067 62.79C466.419 62.09 466.094 61.2033 466.094 60.13C466.094 59.0367 466.412 58.14 467.047 57.44C467.689 56.74 468.568 56.3233 469.684 56.19V54L471.179 54V56.2C472.302 56.3533 473.174 56.8233 473.796 57.61C474.425 58.3967 474.739 59.4733 474.739 60.84H472.894C472.894 59.9 472.67 59.1533 472.222 58.6C471.774 58.0467 471.169 57.77 470.407 57.77C469.611 57.77 469.003 57.9767 468.581 58.39C468.16 58.7967 467.95 59.3667 467.95 60.1C467.95 60.78 468.17 61.3233 468.611 61.73C469.059 62.13 469.791 62.4967 470.808 62.83C471.831 63.1567 472.626 63.52 473.194 63.92C473.769 64.3133 474.191 64.7733 474.458 65.3C474.732 65.8267 474.869 66.4433 474.869 67.15C474.869 68.2767 474.528 69.1833 473.846 69.87C473.171 70.5567 472.222 70.9633 470.998 71.09V73H469.514V71.09C468.27 70.9767 467.294 70.5367 466.586 69.77C465.884 68.9967 465.533 67.95 465.533 66.63H467.388C467.388 67.5567 467.632 68.27 468.12 68.77C468.608 69.27 469.3 69.52 470.196 69.52C471.072 69.52 471.76 69.31 472.262 68.89C472.763 68.47 473.014 67.8967 473.014 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M484.547 67.17C484.547 66.5567 484.329 66.04 483.895 65.62C483.467 65.2 482.742 64.82 481.719 64.48C480.295 64.0467 479.255 63.4833 478.6 62.79C477.951 62.09 477.627 61.2033 477.627 60.13C477.627 59.0367 477.945 58.14 478.58 57.44C479.222 56.74 480.101 56.3233 481.217 56.19V54L482.711 54V56.2C483.835 56.3533 484.707 56.8233 485.329 57.61C485.957 58.3967 486.272 59.4733 486.272 60.84H484.426C484.426 59.9 484.202 59.1533 483.754 58.6C483.306 58.0467 482.701 57.77 481.939 57.77C481.144 57.77 480.535 57.9767 480.114 58.39C479.693 58.7967 479.482 59.3667 479.482 60.1C479.482 60.78 479.703 61.3233 480.144 61.73C480.592 62.13 481.324 62.4967 482.34 62.83C483.363 63.1567 484.159 63.52 484.727 63.92C485.302 64.3133 485.723 64.7733 485.991 65.3C486.265 65.8267 486.402 66.4433 486.402 67.15C486.402 68.2767 486.061 69.1833 485.379 69.87C484.704 70.5567 483.754 70.9633 482.531 71.09V73H481.047V71.09C479.803 70.9767 478.827 70.5367 478.118 69.77C477.416 68.9967 477.065 67.95 477.065 66.63H478.921C478.921 67.5567 479.165 68.27 479.653 68.77C480.141 69.27 480.833 69.52 481.729 69.52C482.604 69.52 483.293 69.31 483.794 68.89C484.296 68.47 484.547 67.8967 484.547 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M496.079 67.17C496.079 66.5567 495.862 66.04 495.427 65.62C495 65.2 494.274 64.82 493.251 64.48C491.827 64.0467 490.788 63.4833 490.132 62.79C489.484 62.09 489.16 61.2033 489.16 60.13C489.16 59.0367 489.477 58.14 490.112 57.44C490.754 56.74 491.633 56.3233 492.75 56.19V54L494.244 54V56.2C495.367 56.3533 496.24 56.8233 496.862 57.61C497.49 58.3967 497.804 59.4733 497.804 60.84H495.959C495.959 59.9 495.735 59.1533 495.287 58.6C494.839 58.0467 494.234 57.77 493.472 57.77C492.676 57.77 492.068 57.9767 491.647 58.39C491.226 58.7967 491.015 59.3667 491.015 60.1C491.015 60.78 491.236 61.3233 491.677 61.73C492.125 62.13 492.857 62.4967 493.873 62.83C494.896 63.1567 495.692 63.52 496.26 63.92C496.835 64.3133 497.256 64.7733 497.523 65.3C497.798 65.8267 497.935 66.4433 497.935 67.15C497.935 68.2767 497.594 69.1833 496.912 69.87C496.236 70.5567 495.287 70.9633 494.064 71.09V73H492.579V71.09C491.336 70.9767 490.36 70.5367 489.651 69.77C488.949 68.9967 488.598 67.95 488.598 66.63H490.453C490.453 67.5567 490.697 68.27 491.185 68.77C491.674 69.27 492.365 69.52 493.261 69.52C494.137 69.52 494.826 69.31 495.327 68.89C495.829 68.47 496.079 67.8967 496.079 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M507.612 67.17C507.612 66.5567 507.395 66.04 506.96 65.62C506.532 65.2 505.807 64.82 504.784 64.48C503.36 64.0467 502.32 63.4833 501.665 62.79C501.017 62.09 500.692 61.2033 500.692 60.13C500.692 59.0367 501.01 58.14 501.645 57.44C502.287 56.74 503.166 56.3233 504.283 56.19V54L505.777 54V56.2C506.9 56.3533 507.772 56.8233 508.394 57.61C509.023 58.3967 509.337 59.4733 509.337 60.84H507.492C507.492 59.9 507.268 59.1533 506.82 58.6C506.372 58.0467 505.767 57.77 505.005 57.77C504.209 57.77 503.601 57.9767 503.179 58.39C502.758 58.7967 502.548 59.3667 502.548 60.1C502.548 60.78 502.768 61.3233 503.21 61.73C503.657 62.13 504.39 62.4967 505.406 62.83C506.429 63.1567 507.224 63.52 507.793 63.92C508.368 64.3133 508.789 64.7733 509.056 65.3C509.33 65.8267 509.467 66.4433 509.467 67.15C509.467 68.2767 509.126 69.1833 508.444 69.87C507.769 70.5567 506.82 70.9633 505.596 71.09V73H504.112V71.09C502.869 70.9767 501.892 70.5367 501.184 69.77C500.482 68.9967 500.131 67.95 500.131 66.63H501.986C501.986 67.5567 502.23 68.27 502.718 68.77C503.206 69.27 503.898 69.52 504.794 69.52C505.67 69.52 506.358 69.31 506.86 68.89C507.361 68.47 507.612 67.8967 507.612 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M519.145 67.17C519.145 66.5567 518.927 66.04 518.493 65.62C518.065 65.2 517.34 64.82 516.317 64.48C514.893 64.0467 513.853 63.4833 513.198 62.79C512.549 62.09 512.225 61.2033 512.225 60.13C512.225 59.0367 512.543 58.14 513.178 57.44C513.82 56.74 514.699 56.3233 515.815 56.19V54L517.31 54V56.2C518.433 56.3533 519.305 56.8233 519.927 57.61C520.555 58.3967 520.87 59.4733 520.87 60.84H519.024C519.024 59.9 518.8 59.1533 518.352 58.6C517.905 58.0467 517.3 57.77 516.537 57.77C515.742 57.77 515.133 57.9767 514.712 58.39C514.291 58.7967 514.08 59.3667 514.08 60.1C514.08 60.78 514.301 61.3233 514.742 61.73C515.19 62.13 515.922 62.4967 516.938 62.83C517.961 63.1567 518.757 63.52 519.325 63.92C519.9 64.3133 520.321 64.7733 520.589 65.3C520.863 65.8267 521 66.4433 521 67.15C521 68.2767 520.659 69.1833 519.977 69.87C519.302 70.5567 518.352 70.9633 517.129 71.09V73H515.645V71.09C514.401 70.9767 513.425 70.5367 512.717 69.77C512.015 68.9967 511.664 67.95 511.664 66.63H513.519C513.519 67.5567 513.763 68.27 514.251 68.77C514.739 69.27 515.431 69.52 516.327 69.52C517.203 69.52 517.891 69.31 518.393 68.89C518.894 68.47 519.145 67.8967 519.145 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M429.644 96.8689H428.67L424.973 91.1209V96.8689H424L424 89.4098H424.973L428.68 95.1834V89.4098H429.644V96.8689Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M433.826 96.9713C433.086 96.9713 432.485 96.7254 432.021 96.2336C431.557 95.7384 431.325 95.0775 431.325 94.251V94.0768C431.325 93.527 431.427 93.0369 431.632 92.6066C431.841 92.1728 432.13 91.8347 432.5 91.5922C432.873 91.3463 433.276 91.2234 433.71 91.2234C434.42 91.2234 434.971 91.4607 435.364 91.9355C435.758 92.4102 435.955 93.0898 435.955 93.9744V94.3689H432.258C432.271 94.9153 432.427 95.3576 432.727 95.6957C433.029 96.0304 433.413 96.1977 433.877 96.1977C434.206 96.1977 434.485 96.1294 434.714 95.9928C434.942 95.8562 435.143 95.6752 435.314 95.4498L435.884 95.9006C435.427 96.6144 434.741 96.9713 433.826 96.9713ZM433.71 92.002C433.334 92.002 433.018 92.1421 432.762 92.4221C432.506 92.6988 432.348 93.0881 432.288 93.5902H435.021V93.5184C434.995 93.0369 434.867 92.6646 434.638 92.4016C434.41 92.1352 434.1 92.002 433.71 92.002Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M438.649 89.9836V91.3258L439.668 91.3258V92.0584L438.649 92.0584V95.4959C438.649 95.7179 438.695 95.8852 438.785 95.998C438.876 96.1072 439.031 96.1619 439.249 96.1619C439.357 96.1619 439.505 96.1414 439.693 96.1004L439.693 96.8689C439.448 96.9372 439.209 96.9713 438.977 96.9713C438.56 96.9713 438.246 96.8432 438.034 96.5871C437.822 96.3309 437.716 95.9672 437.716 95.4959V92.0584H436.723V91.3258H437.716V89.9836H438.649Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M449.808 93.3801C449.808 94.111 449.687 94.7497 449.445 95.2961C449.203 95.8391 448.86 96.2541 448.416 96.541C447.972 96.8279 447.454 96.9713 446.863 96.9713C446.284 96.9713 445.772 96.8279 445.324 96.541C444.877 96.2507 444.529 95.8391 444.28 95.3064C444.035 94.7701 443.909 94.1503 443.902 93.4467V92.9088C443.902 92.1916 444.025 91.5581 444.27 91.0082C444.516 90.4583 444.862 90.0383 445.309 89.748C445.76 89.4542 446.274 89.3074 446.853 89.3074C447.441 89.3074 447.959 89.4525 448.406 89.7428C448.857 90.0297 449.203 90.4481 449.445 90.998C449.687 91.5444 449.808 92.1814 449.808 92.9088V93.3801ZM448.845 92.8986C448.845 92.014 448.67 91.3361 448.32 90.8648C447.971 90.39 447.481 90.1527 446.853 90.1527C446.241 90.1527 445.758 90.39 445.405 90.8648C445.055 91.3361 444.876 91.9918 444.865 92.832V93.3801C444.865 94.2374 445.042 94.9119 445.395 95.4037C445.751 95.8921 446.241 96.1363 446.863 96.1363C447.488 96.1363 447.972 95.9057 448.315 95.4447C448.658 94.9802 448.835 94.3159 448.845 93.4518V92.8986Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M452.341 91.3258L452.372 92.0225C452.789 91.4898 453.333 91.2234 454.006 91.2234C455.159 91.2234 455.741 91.8842 455.751 93.2059V96.8689H454.818V93.2008C454.814 92.8012 454.724 92.5058 454.545 92.3145C454.371 92.1233 454.096 92.0277 453.723 92.0277C453.421 92.0277 453.155 92.1096 452.926 92.2736C452.698 92.4375 452.52 92.6527 452.392 92.9191V96.8689H451.459V91.3258H452.341Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M459.444 94.0871L456.983 94.0871V93.3135L459.444 93.3135V94.0871Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M460.847 96.8689V89.4098L462.92 89.4098C463.559 89.4098 464.124 89.5533 464.615 89.8402C465.106 90.127 465.484 90.5352 465.75 91.0645C466.019 91.5939 466.155 92.2018 466.158 92.8883V93.3648C466.158 94.0683 466.024 94.6848 465.755 95.2141C465.489 95.7435 465.108 96.1499 464.61 96.4334C464.116 96.7169 463.539 96.862 462.88 96.8689H460.847ZM461.816 90.2193V96.0645H462.835C463.581 96.0645 464.161 95.8289 464.575 95.3576C464.992 94.8863 465.2 94.2152 465.2 93.3443V92.9088C465.2 92.0618 465.003 91.4044 464.61 90.9365C464.22 90.4652 463.665 90.2261 462.946 90.2193H461.816Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M470.089 96.9713C469.349 96.9713 468.747 96.7254 468.283 96.2336C467.819 95.7384 467.587 95.0775 467.587 94.251V94.0768C467.587 93.527 467.69 93.0369 467.895 92.6066C468.103 92.1728 468.392 91.8347 468.762 91.5922C469.135 91.3463 469.539 91.2234 469.973 91.2234C470.682 91.2234 471.233 91.4607 471.627 91.9355C472.02 92.4102 472.217 93.0898 472.217 93.9744V94.3689H468.52C468.533 94.9153 468.69 95.3576 468.989 95.6957C469.292 96.0304 469.675 96.1977 470.139 96.1977C470.469 96.1977 470.748 96.1294 470.976 95.9928C471.205 95.8562 471.405 95.6752 471.576 95.4498L472.146 95.9006C471.689 96.6144 471.003 96.9713 470.089 96.9713ZM469.973 92.002C469.596 92.002 469.28 92.1421 469.024 92.4221C468.769 92.6988 468.611 93.0881 468.55 93.5902H471.284V93.5184C471.257 93.0369 471.129 92.6646 470.901 92.4016C470.672 92.1352 470.363 92.002 469.973 92.002Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M474.523 91.3258L474.548 91.9406C474.949 91.4624 475.488 91.2234 476.167 91.2234C476.931 91.2234 477.45 91.5205 477.726 92.1148C477.907 91.8484 478.143 91.6332 478.432 91.4693C478.724 91.3053 479.069 91.2234 479.466 91.2234C480.663 91.2234 481.271 91.8671 481.292 93.1547V96.8689H480.359V93.2111C480.359 92.8149 480.269 92.5195 480.091 92.3248C479.913 92.1267 479.614 92.0277 479.193 92.0277C478.847 92.0277 478.56 92.1335 478.331 92.3453C478.102 92.5536 477.97 92.8354 477.933 93.1906V96.8689H476.995V93.2367C476.995 92.4307 476.606 92.0277 475.829 92.0277C475.217 92.0277 474.799 92.2923 474.574 92.8217V96.8689H473.641V91.3258H474.523Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M486.417 96.8689C486.363 96.7596 486.32 96.5649 486.286 96.2848C485.852 96.7425 485.335 96.9713 484.733 96.9713C484.195 96.9713 483.753 96.8176 483.406 96.5102C483.063 96.1995 482.892 95.8067 482.892 95.332C482.892 94.7548 483.107 94.3074 483.537 93.9898C483.971 93.6687 484.58 93.5082 485.363 93.5082H486.271V93.0727C486.271 92.7415 486.173 92.4785 485.978 92.2838C485.783 92.0857 485.496 91.9867 485.116 91.9867C484.783 91.9867 484.504 92.0721 484.279 92.2428C484.053 92.4136 483.941 92.6202 483.941 92.8627H483.003C483.003 92.5861 483.099 92.3197 483.29 92.0635C483.485 91.804 483.747 91.599 484.077 91.4488C484.41 91.2985 484.775 91.2234 485.171 91.2234C485.8 91.2234 486.293 91.3839 486.649 91.7049C487.006 92.0225 487.191 92.4614 487.204 93.0215V95.5727C487.204 96.0816 487.268 96.4863 487.396 96.7869V96.8689H486.417ZM484.869 96.1465C485.161 96.1465 485.439 96.0697 485.701 95.916C485.963 95.7623 486.153 95.5625 486.271 95.3166V94.1793H485.54C484.396 94.1793 483.825 94.5191 483.825 95.1988C483.825 95.4959 483.922 95.7281 484.117 95.8955C484.312 96.0628 484.563 96.1465 484.869 96.1465Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M489.894 91.3258L489.924 92.0225C490.341 91.4898 490.885 91.2234 491.558 91.2234C492.711 91.2234 493.293 91.8842 493.303 93.2059V96.8689H492.37V93.2008C492.367 92.8012 492.276 92.5058 492.098 92.3145C491.923 92.1233 491.649 92.0277 491.275 92.0277C490.973 92.0277 490.707 92.1096 490.479 92.2736C490.25 92.4375 490.072 92.6527 489.944 92.9191V96.8689H489.011V91.3258H489.894Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M494.827 94.0512C494.827 93.2008 495.026 92.5178 495.423 92.002C495.819 91.4829 496.339 91.2234 496.981 91.2234C497.62 91.2234 498.126 91.4454 498.499 91.8893V89L499.432 89V96.8689H498.575L498.529 96.2746C498.156 96.7391 497.637 96.9713 496.971 96.9713C496.339 96.9713 495.823 96.7083 495.423 96.1824C495.026 95.6564 494.827 94.9699 494.827 94.123V94.0512ZM495.761 94.1588C495.761 94.7872 495.888 95.279 496.144 95.6342C496.399 95.9894 496.752 96.167 497.203 96.167C497.795 96.167 498.227 95.8972 498.499 95.3576V92.8115C498.22 92.2889 497.791 92.0277 497.213 92.0277C496.756 92.0277 496.399 92.207 496.144 92.5656C495.888 92.9242 495.761 93.4553 495.761 94.1588Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M506.445 93.5441C505.615 93.3016 505.01 93.0044 504.63 92.6527C504.253 92.2975 504.065 91.8603 504.065 91.3412C504.065 90.7538 504.295 90.2688 504.756 89.8863C505.22 89.5003 505.822 89.3074 506.561 89.3074C507.066 89.3074 507.515 89.4064 507.908 89.6045C508.305 89.8026 508.611 90.0758 508.826 90.4242C509.045 90.7725 509.154 91.1533 509.154 91.5666H508.18C508.18 91.1158 508.039 90.7623 507.757 90.5061C507.474 90.2466 507.076 90.1168 506.561 90.1168C506.084 90.1168 505.711 90.2244 505.442 90.4395C505.176 90.6513 505.043 90.9467 505.043 91.3258C505.043 91.6298 505.169 91.8876 505.422 92.0994C505.677 92.3077 506.109 92.499 506.718 92.6732C507.33 92.8473 507.807 93.0403 508.15 93.252C508.496 93.4604 508.752 93.7046 508.917 93.9846C509.085 94.2647 509.169 94.5943 509.169 94.9734C509.169 95.5779 508.937 96.0628 508.473 96.4283C508.009 96.7903 507.389 96.9713 506.612 96.9713C506.108 96.9713 505.637 96.874 505.2 96.6793C504.763 96.4812 504.425 96.2114 504.186 95.8699C503.951 95.5283 503.833 95.1407 503.833 94.707H504.806C504.806 95.1578 504.969 95.5147 505.295 95.7777C505.625 96.0372 506.064 96.167 506.612 96.167C507.123 96.167 507.515 96.0611 507.787 95.8494C508.059 95.6376 508.196 95.349 508.196 94.9836C508.196 94.6182 508.069 94.3364 507.817 94.1383C507.565 93.9368 507.108 93.7387 506.445 93.5441Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M515.223 94.1588C515.223 95.0024 515.033 95.682 514.653 96.1977C514.273 96.7135 513.758 96.9713 513.109 96.9713C512.447 96.9713 511.926 96.7579 511.546 96.3309V99H510.613V91.3258H511.465L511.51 91.9406C511.89 91.4624 512.418 91.2234 513.094 91.2234C513.75 91.2234 514.268 91.4744 514.648 91.9764C515.031 92.4785 515.223 93.1769 515.223 94.0717V94.1588ZM514.289 94.0512C514.289 93.4262 514.158 92.9327 513.896 92.5707C513.634 92.2087 513.274 92.0277 512.817 92.0277C512.252 92.0277 511.828 92.2821 511.546 92.791V95.4395C511.825 95.945 512.252 96.1977 512.827 96.1977C513.274 96.1977 513.629 96.0184 513.891 95.6598C514.157 95.2978 514.289 94.7616 514.289 94.0512Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M519.022 96.9713C518.282 96.9713 517.68 96.7254 517.216 96.2336C516.752 95.7384 516.52 95.0775 516.52 94.251V94.0768C516.52 93.527 516.623 93.0369 516.828 92.6066C517.036 92.1728 517.325 91.8347 517.695 91.5922C518.068 91.3463 518.472 91.2234 518.906 91.2234C519.615 91.2234 520.167 91.4607 520.56 91.9355C520.953 92.4102 521.15 93.0898 521.15 93.9744V94.3689H517.453C517.467 94.9153 517.623 95.3576 517.922 95.6957C518.225 96.0304 518.608 96.1977 519.072 96.1977C519.402 96.1977 519.681 96.1294 519.909 95.9928C520.138 95.8562 520.338 95.6752 520.51 95.4498L521.079 95.9006C520.622 96.6144 519.936 96.9713 519.022 96.9713ZM518.906 92.002C518.529 92.002 518.213 92.1421 517.957 92.4221C517.702 92.6988 517.544 93.0881 517.483 93.5902H520.217V93.5184C520.19 93.0369 520.062 92.6646 519.834 92.4016C519.605 92.1352 519.296 92.002 518.906 92.002Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M523.461 91.3258L523.492 92.0225C523.909 91.4898 524.453 91.2234 525.126 91.2234C526.279 91.2234 526.861 91.8842 526.871 93.2059V96.8689H525.938V93.2008C525.934 92.8012 525.844 92.5058 525.665 92.3145C525.491 92.1233 525.216 92.0277 524.843 92.0277C524.541 92.0277 524.275 92.1096 524.046 92.2736C523.818 92.4375 523.64 92.6527 523.512 92.9191V96.8689H522.579V91.3258H523.461Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M528.395 94.0512C528.395 93.2008 528.594 92.5178 528.99 92.002C529.387 91.4829 529.907 91.2234 530.549 91.2234C531.188 91.2234 531.694 91.4454 532.067 91.8893V89L533 89V96.8689H532.143L532.097 96.2746C531.724 96.7391 531.205 96.9713 530.539 96.9713C529.907 96.9713 529.391 96.7083 528.99 96.1824C528.594 95.6564 528.395 94.9699 528.395 94.123V94.0512ZM529.328 94.1588C529.328 94.7872 529.456 95.279 529.712 95.6342C529.967 95.9894 530.32 96.167 530.771 96.167C531.363 96.167 531.795 95.8972 532.067 95.3576V92.8115C531.788 92.2889 531.359 92.0277 530.781 92.0277C530.324 92.0277 529.967 92.207 529.712 92.5656C529.456 92.9242 529.328 93.4553 529.328 94.1588Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M286.492 67.17C286.492 66.5567 286.275 66.04 285.84 65.62C285.411 65.2 284.685 64.82 283.66 64.48C282.234 64.0467 281.193 63.4833 280.537 62.79C279.887 62.09 279.562 61.2033 279.562 60.13C279.562 59.0367 279.88 58.14 280.517 57.44C281.159 56.74 282.04 56.3233 283.158 56.19V54L284.654 54V56.2C285.779 56.3533 286.653 56.8233 287.276 57.61C287.905 58.3967 288.22 59.4733 288.22 60.84H286.372C286.372 59.9 286.148 59.1533 285.699 58.6C285.25 58.0467 284.644 57.77 283.881 57.77C283.084 57.77 282.475 57.9767 282.053 58.39C281.631 58.7967 281.42 59.3667 281.42 60.1C281.42 60.78 281.641 61.3233 282.083 61.73C282.532 62.13 283.265 62.4967 284.283 62.83C285.307 63.1567 286.104 63.52 286.673 63.92C287.249 64.3133 287.671 64.7733 287.939 65.3C288.213 65.8267 288.35 66.4433 288.35 67.15C288.35 68.2767 288.009 69.1833 287.326 69.87C286.65 70.5567 285.699 70.9633 284.474 71.09V73H282.987V71.09C281.742 70.9767 280.764 70.5367 280.055 69.77C279.352 68.9967 279 67.95 279 66.63H280.858C280.858 67.5567 281.102 68.27 281.591 68.77C282.08 69.27 282.773 69.52 283.67 69.52C284.547 69.52 285.237 69.31 285.739 68.89C286.241 68.47 286.492 67.8967 286.492 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M298.042 67.17C298.042 66.5567 297.825 66.04 297.389 65.62C296.961 65.2 296.234 64.82 295.21 64.48C293.784 64.0467 292.743 63.4833 292.087 62.79C291.437 62.09 291.112 61.2033 291.112 60.13C291.112 59.0367 291.43 58.14 292.066 57.44C292.709 56.74 293.59 56.3233 294.708 56.19V54L296.204 54V56.2C297.329 56.3533 298.203 56.8233 298.826 57.61C299.455 58.3967 299.77 59.4733 299.77 60.84H297.922C297.922 59.9 297.697 59.1533 297.249 58.6C296.8 58.0467 296.194 57.77 295.431 57.77C294.634 57.77 294.025 57.9767 293.603 58.39C293.181 58.7967 292.97 59.3667 292.97 60.1C292.97 60.78 293.191 61.3233 293.633 61.73C294.082 62.13 294.815 62.4967 295.833 62.83C296.857 63.1567 297.654 63.52 298.223 63.92C298.799 64.3133 299.221 64.7733 299.488 65.3C299.763 65.8267 299.9 66.4433 299.9 67.15C299.9 68.2767 299.559 69.1833 298.876 69.87C298.2 70.5567 297.249 70.9633 296.024 71.09V73H294.537V71.09C293.292 70.9767 292.314 70.5367 291.604 69.77C290.901 68.9967 290.55 67.95 290.55 66.63H292.408C292.408 67.5567 292.652 68.27 293.141 68.77C293.63 69.27 294.323 69.52 295.22 69.52C296.097 69.52 296.787 69.31 297.289 68.89C297.791 68.47 298.042 67.8967 298.042 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M309.592 67.17C309.592 66.5567 309.374 66.04 308.939 65.62C308.511 65.2 307.784 64.82 306.76 64.48C305.334 64.0467 304.293 63.4833 303.636 62.79C302.987 62.09 302.662 61.2033 302.662 60.13C302.662 59.0367 302.98 58.14 303.616 57.44C304.259 56.74 305.14 56.3233 306.258 56.19V54L307.754 54V56.2C308.879 56.3533 309.753 56.8233 310.375 57.61C311.005 58.3967 311.32 59.4733 311.32 60.84H309.472C309.472 59.9 309.247 59.1533 308.799 58.6C308.35 58.0467 307.744 57.77 306.981 57.77C306.184 57.77 305.575 57.9767 305.153 58.39C304.731 58.7967 304.52 59.3667 304.52 60.1C304.52 60.78 304.741 61.3233 305.183 61.73C305.632 62.13 306.365 62.4967 307.383 62.83C308.407 63.1567 309.204 63.52 309.773 63.92C310.349 64.3133 310.771 64.7733 311.038 65.3C311.313 65.8267 311.45 66.4433 311.45 67.15C311.45 68.2767 311.109 69.1833 310.426 69.87C309.749 70.5567 308.799 70.9633 307.573 71.09V73H306.087V71.09C304.842 70.9767 303.864 70.5367 303.154 69.77C302.451 68.9967 302.1 67.95 302.1 66.63H303.958C303.958 67.5567 304.202 68.27 304.691 68.77C305.18 69.27 305.873 69.52 306.77 69.52C307.647 69.52 308.337 69.31 308.839 68.89C309.341 68.47 309.592 67.8967 309.592 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M321.142 67.17C321.142 66.5567 320.924 66.04 320.489 65.62C320.061 65.2 319.334 64.82 318.31 64.48C316.884 64.0467 315.842 63.4833 315.186 62.79C314.537 62.09 314.212 61.2033 314.212 60.13C314.212 59.0367 314.53 58.14 315.166 57.44C315.809 56.74 316.689 56.3233 317.808 56.19V54L319.304 54V56.2C320.429 56.3533 321.303 56.8233 321.925 57.61C322.555 58.3967 322.869 59.4733 322.869 60.84H321.021C321.021 59.9 320.797 59.1533 320.349 58.6C319.9 58.0467 319.294 57.77 318.531 57.77C317.734 57.77 317.125 57.9767 316.703 58.39C316.281 58.7967 316.07 59.3667 316.07 60.1C316.07 60.78 316.291 61.3233 316.733 61.73C317.182 62.13 317.915 62.4967 318.932 62.83C319.957 63.1567 320.754 63.52 321.323 63.92C321.899 64.3133 322.32 64.7733 322.588 65.3C322.863 65.8267 323 66.4433 323 67.15C323 68.2767 322.659 69.1833 321.976 69.87C321.299 70.5567 320.349 70.9633 319.123 71.09V73H317.637V71.09C316.391 70.9767 315.414 70.5367 314.704 69.77C314.001 68.9967 313.65 67.95 313.65 66.63H315.508C315.508 67.5567 315.752 68.27 316.241 68.77C316.73 69.27 317.423 69.52 318.32 69.52C319.197 69.52 319.887 69.31 320.389 68.89C320.891 68.47 321.142 67.8967 321.142 67.17Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M110 60.014C110 59.1395 110.275 58.4186 110.826 57.8511C111.384 57.2837 112.097 57 112.966 57C113.849 57 114.562 57.287 115.106 57.8611C115.657 58.4286 115.933 59.1662 115.933 60.0741V60.785C115.933 61.6662 115.654 62.3872 115.096 62.9479C114.546 63.502 113.842 63.779 112.986 63.779C112.124 63.779 111.41 63.502 110.846 62.9479C110.282 62.3872 110 61.6429 110 60.715L110 60.014ZM111.374 60.785C111.374 61.3057 111.52 61.7363 111.812 62.0768C112.104 62.4105 112.495 62.5774 112.986 62.5774C113.457 62.5774 113.836 62.4139 114.121 62.0868C114.413 61.7597 114.559 61.3124 114.559 60.745V60.014C114.559 59.4933 114.416 59.0628 114.131 58.7223C113.846 58.3818 113.457 58.2116 112.966 58.2116C112.475 58.2116 112.087 58.3818 111.802 58.7223C111.516 59.0628 111.374 59.5067 111.374 60.0541V60.785ZM117.057 68.215C117.057 67.3405 117.333 66.6228 117.884 66.0621C118.441 65.4947 119.154 65.2109 120.024 65.2109C120.893 65.2109 121.606 65.4913 122.164 66.0521C122.721 66.6128 123 67.3571 123 68.285V68.996C123 69.8705 122.721 70.5915 122.164 71.1589C121.613 71.7196 120.906 72 120.044 72C119.181 72 118.468 71.723 117.904 71.1689C117.339 70.6081 117.057 69.8638 117.057 68.9359V68.215ZM118.431 68.996C118.431 69.5234 118.577 69.9573 118.869 70.2977C119.161 70.6315 119.553 70.7984 120.044 70.7984C120.521 70.7984 120.903 70.6348 121.188 70.3077C121.474 69.974 121.616 69.5234 121.616 68.9559V68.215C121.616 67.6876 121.47 67.257 121.178 66.9232C120.893 66.5895 120.508 66.4226 120.024 66.4226C119.553 66.4226 119.168 66.5895 118.869 66.9232C118.577 67.2503 118.431 67.6943 118.431 68.255V68.996ZM113.404 70.6883L112.359 70.0274L119.436 58.6322L120.482 59.2931L113.404 70.6883Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M256.253 92.7033H256.952C257.391 92.6965 257.736 92.5778 257.988 92.3475C258.239 92.1171 258.365 91.8059 258.365 91.4139C258.365 90.5336 257.937 90.0935 257.083 90.0935C256.68 90.0935 256.359 90.2121 256.117 90.4494C255.879 90.6832 255.76 90.9944 255.76 91.3829H254.83C254.83 90.7881 255.041 90.2946 255.464 89.9026C255.889 89.5072 256.429 89.3095 257.083 89.3095C257.773 89.3095 258.314 89.4969 258.707 89.8717C259.099 90.2465 259.295 90.7674 259.295 91.4345C259.295 91.7612 259.191 92.0775 258.983 92.3836C258.779 92.6896 258.499 92.9183 258.144 93.0696C258.546 93.2002 258.856 93.4168 259.074 93.7194C259.295 94.022 259.405 94.3917 259.405 94.8284C259.405 95.5023 259.191 96.037 258.762 96.4325C258.333 96.8279 257.775 97.0256 257.088 97.0256C256.401 97.0256 255.841 96.8348 255.408 96.4531C254.979 96.0714 254.765 95.5677 254.765 94.9419H255.7C255.7 95.3373 255.826 95.6536 256.077 95.8909C256.329 96.1282 256.665 96.2468 257.088 96.2468C257.537 96.2468 257.88 96.1264 258.118 95.8857C258.356 95.645 258.475 95.2995 258.475 94.849C258.475 94.4123 258.345 94.0771 258.083 93.8432C257.822 93.6094 257.445 93.4891 256.952 93.4822H256.253V92.7033Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M264.893 91.3417L264.919 91.9606C265.317 91.4792 265.855 91.2385 266.532 91.2385C267.293 91.2385 267.811 91.5377 268.086 92.136C268.267 91.8678 268.502 91.6511 268.79 91.4861C269.081 91.321 269.425 91.2385 269.82 91.2385C271.014 91.2385 271.62 91.8867 271.641 93.183V96.9225H270.71V93.2398C270.71 92.8409 270.622 92.5435 270.444 92.3475C270.266 92.148 269.968 92.0483 269.549 92.0483C269.204 92.0483 268.917 92.1549 268.689 92.3681C268.461 92.5778 268.329 92.8615 268.292 93.2191V96.9225H267.357V93.2656C267.357 92.454 266.97 92.0483 266.196 92.0483C265.585 92.0483 265.168 92.3148 264.944 92.8478V96.9225H264.014V91.3417H264.893Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M273.145 94.0805C273.145 93.5338 273.249 93.042 273.457 92.6053C273.668 92.1686 273.96 91.8317 274.332 91.5944C274.707 91.3571 275.134 91.2385 275.614 91.2385C276.355 91.2385 276.953 91.5016 277.409 92.0277C277.868 92.5538 278.097 93.2535 278.097 94.1269V94.194C278.097 94.7373 277.995 95.2255 277.791 95.6588C277.59 96.0886 277.3 96.4239 276.921 96.6646C276.546 96.9053 276.113 97.0256 275.624 97.0256C274.886 97.0256 274.288 96.7626 273.829 96.2365C273.373 95.7104 273.145 95.0141 273.145 94.1475V94.0805ZM274.08 94.194C274.08 94.8129 274.219 95.3098 274.498 95.6846C274.779 96.0594 275.155 96.2468 275.624 96.2468C276.096 96.2468 276.472 96.0577 276.75 95.6794C277.028 95.2977 277.167 94.7648 277.167 94.0805C277.167 93.4684 277.025 92.9733 276.74 92.595C276.458 92.2133 276.083 92.0225 275.614 92.0225C275.155 92.0225 274.784 92.2099 274.503 92.5847C274.221 92.9595 274.08 93.4959 274.08 94.194Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M280.487 91.3417L280.517 92.0431C280.933 91.5067 281.476 91.2385 282.146 91.2385C283.296 91.2385 283.876 91.9039 283.886 93.2346V96.9225H282.956V93.2294C282.952 92.8271 282.862 92.5297 282.684 92.3371C282.51 92.1446 282.237 92.0483 281.865 92.0483C281.563 92.0483 281.298 92.1308 281.07 92.2959C280.842 92.4609 280.665 92.6776 280.537 92.9458V96.9225H279.607V91.3417H280.487Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M286.894 89.9903V91.3417H287.909V92.0792H286.894V95.5402C286.894 95.7637 286.939 95.9322 287.029 96.0456C287.12 96.1557 287.274 96.2107 287.492 96.2107C287.599 96.2107 287.747 96.1901 287.934 96.1488V96.9225C287.69 96.9912 287.452 97.0256 287.22 97.0256C286.805 97.0256 286.491 96.8967 286.28 96.6388C286.069 96.3809 285.963 96.0147 285.963 95.5402V92.0792H284.973V91.3417H285.963V89.9903H286.894Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M290.273 92.0173C290.686 91.4981 291.222 91.2385 291.882 91.2385C293.032 91.2385 293.612 91.9039 293.622 93.2346L293.622 96.9225H292.692L292.692 93.2294C292.688 92.8271 292.598 92.5297 292.42 92.3371C292.246 92.1446 291.973 92.0483 291.601 92.0483C291.299 92.0483 291.034 92.1308 290.806 92.2959C290.579 92.4609 290.401 92.6776 290.273 92.9458L290.273 96.9225H289.343L289.343 89L290.273 89V92.0173Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M298.525 95.4422C298.525 95.1843 298.43 94.9848 298.239 94.8439C298.051 94.6994 297.721 94.5756 297.248 94.4725C296.779 94.3693 296.405 94.2455 296.127 94.1011C295.852 93.9567 295.648 93.7848 295.514 93.5853C295.383 93.3859 295.318 93.1486 295.318 92.8736C295.318 92.4162 295.505 92.0294 295.881 91.713C296.259 91.3967 296.742 91.2385 297.329 91.2385C297.945 91.2385 298.445 91.4018 298.827 91.7285C299.212 92.0552 299.405 92.473 299.405 92.9819H298.47C298.47 92.7205 298.361 92.4953 298.143 92.3062C297.929 92.1171 297.657 92.0225 297.329 92.0225C296.99 92.0225 296.725 92.0982 296.534 92.2495C296.343 92.4008 296.248 92.5985 296.248 92.8426C296.248 93.073 296.337 93.2466 296.514 93.3636C296.692 93.4805 297.012 93.5922 297.475 93.6988C297.94 93.8054 298.317 93.9326 298.606 94.0805C298.894 94.2284 299.107 94.4072 299.244 94.6169C299.385 94.8232 299.455 95.076 299.455 95.3751C299.455 95.8737 299.261 96.2743 298.872 96.5769C298.483 96.8761 297.979 97.0256 297.359 97.0256C296.923 97.0256 296.538 96.9465 296.202 96.7884C295.867 96.6302 295.604 96.4101 295.413 96.1282C295.225 95.8428 295.132 95.535 295.132 95.2049H296.062C296.078 95.5247 296.202 95.7791 296.434 95.9683C296.668 96.154 296.977 96.2468 297.359 96.2468C297.711 96.2468 297.992 96.1746 298.204 96.0302C298.418 95.8823 298.525 95.6863 298.525 95.4422Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M307.075 95.4422C307.075 95.1843 306.98 94.9848 306.788 94.8439C306.601 94.6994 306.271 94.5756 305.798 94.4725C305.329 94.3693 304.955 94.2455 304.677 94.1011C304.402 93.9567 304.198 93.7848 304.063 93.5853C303.933 93.3859 303.867 93.1486 303.867 92.8736C303.867 92.4162 304.055 92.0294 304.43 91.713C304.809 91.3967 305.292 91.2385 305.878 91.2385C306.495 91.2385 306.995 91.4018 307.377 91.7285C307.762 92.0552 307.955 92.473 307.955 92.9819H307.02C307.02 92.7205 306.911 92.4953 306.693 92.3062C306.478 92.1171 306.207 92.0225 305.878 92.0225C305.54 92.0225 305.275 92.0982 305.084 92.2495C304.893 92.4008 304.797 92.5985 304.797 92.8426C304.797 93.073 304.886 93.2466 305.064 93.3636C305.242 93.4805 305.562 93.5922 306.024 93.6988C306.49 93.8054 306.867 93.9326 307.155 94.0805C307.444 94.2284 307.657 94.4072 307.794 94.6169C307.935 94.8232 308.005 95.076 308.005 95.3751C308.005 95.8737 307.811 96.2743 307.422 96.5769C307.033 96.8761 306.529 97.0256 305.909 97.0256C305.473 97.0256 305.087 96.9465 304.752 96.7884C304.417 96.6302 304.154 96.4101 303.963 96.1282C303.775 95.8428 303.681 95.535 303.681 95.2049H304.611C304.628 95.5247 304.752 95.7791 304.984 95.9683C305.218 96.154 305.527 96.2468 305.909 96.2468C306.261 96.2468 306.542 96.1746 306.753 96.0302C306.968 95.8823 307.075 95.6863 307.075 95.4422Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M312.919 96.9225C312.865 96.8124 312.821 96.6164 312.788 96.3345C312.355 96.7952 311.839 97.0256 311.239 97.0256C310.703 97.0256 310.262 96.8709 309.917 96.5614C309.575 96.2485 309.404 95.8531 309.404 95.3751C309.404 94.794 309.619 94.3435 310.048 94.0238C310.48 93.7005 311.087 93.5389 311.868 93.5389H312.773V93.1005C312.773 92.767 312.676 92.5022 312.481 92.3062C312.287 92.1068 312 92.007 311.621 92.007C311.29 92.007 311.011 92.093 310.787 92.2649C310.562 92.4369 310.45 92.6449 310.45 92.889H309.515C309.515 92.6105 309.61 92.3423 309.801 92.0844C309.996 91.8231 310.257 91.6168 310.586 91.4655C310.918 91.3142 311.281 91.2385 311.677 91.2385C312.303 91.2385 312.795 91.4001 313.15 91.7234C313.505 92.0431 313.689 92.485 313.703 93.0489V95.6175C313.703 96.1299 313.767 96.5374 313.894 96.84V96.9225H312.919ZM311.375 96.1952C311.667 96.1952 311.943 96.1178 312.205 95.9631C312.466 95.8084 312.655 95.6072 312.773 95.3596V94.2146H312.044C310.904 94.2146 310.334 94.5567 310.334 95.241C310.334 95.5402 310.432 95.774 310.626 95.9425C310.82 96.111 311.07 96.1952 311.375 96.1952Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M317.219 95.6279L318.566 91.3417H319.516L317.565 96.9225H316.857L314.886 91.3417H315.836L317.219 95.6279Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M321.765 96.9225H320.835V91.3417H321.765V96.9225ZM320.759 89.8614C320.759 89.7066 320.805 89.576 320.895 89.4694C320.989 89.3628 321.126 89.3095 321.307 89.3095C321.488 89.3095 321.626 89.3628 321.72 89.4694C321.814 89.576 321.86 89.7066 321.86 89.8614C321.86 90.0161 321.814 90.145 321.72 90.2482C321.626 90.3514 321.488 90.4029 321.307 90.4029C321.126 90.4029 320.989 90.3514 320.895 90.2482C320.805 90.145 320.759 90.0161 320.759 89.8614Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M324.481 91.3417L324.511 92.0431C324.927 91.5067 325.47 91.2385 326.14 91.2385C327.29 91.2385 327.87 91.9039 327.88 93.2346V96.9225H326.95V93.2294C326.946 92.8271 326.856 92.5297 326.678 92.3371C326.504 92.1446 326.231 92.0483 325.859 92.0483C325.557 92.0483 325.292 92.1308 325.064 92.2959C324.837 92.4609 324.659 92.6776 324.532 92.9458V96.9225H323.601V91.3417H324.481Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M329.405 94.0857C329.405 93.2157 329.601 92.5245 329.993 92.0122C330.385 91.4964 330.905 91.2385 331.552 91.2385C332.215 91.2385 332.733 91.4792 333.105 91.9606L333.15 91.3417H334V96.7884C334 97.5105 333.791 98.0796 333.372 98.4956C332.956 98.9117 332.396 99.1197 331.692 99.1197C331.3 99.1197 330.916 99.0338 330.541 98.8618C330.166 98.6899 329.879 98.4544 329.681 98.1552L330.164 97.5827C330.563 98.0882 331.05 98.3409 331.627 98.3409C332.079 98.3409 332.431 98.2102 332.683 97.9489C332.937 97.6876 333.065 97.3196 333.065 96.8451V96.3654C332.693 96.8056 332.185 97.0256 331.541 97.0256C330.905 97.0256 330.388 96.7626 329.993 96.2365C329.601 95.7104 329.405 94.9934 329.405 94.0857ZM330.34 94.194C330.34 94.8232 330.466 95.3184 330.717 95.6794C330.968 96.037 331.32 96.2158 331.773 96.2158C332.359 96.2158 332.79 95.9425 333.065 95.3957V92.8478C332.78 92.3148 332.353 92.0483 331.783 92.0483C331.33 92.0483 330.977 92.2288 330.722 92.5899C330.467 92.9509 330.34 93.4856 330.34 94.194Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6043 94.4553C66.7765 94.2112 66.1731 93.912 65.7944 93.5578C65.419 93.2002 65.2313 92.7601 65.2313 92.2374C65.2313 91.646 65.4609 91.1577 65.9201 90.7726C66.3826 90.384 66.9826 90.1897 67.72 90.1897C68.2228 90.1897 68.6702 90.2895 69.0624 90.4889C69.4579 90.6883 69.7629 90.9634 69.9774 91.3142C70.1953 91.6649 70.3042 92.0483 70.3042 92.4644H69.3339C69.3339 92.0105 69.1931 91.6546 68.9115 91.3967C68.63 91.1354 68.2328 91.0047 67.72 91.0047C67.244 91.0047 66.872 91.113 66.6038 91.3296C66.339 91.5428 66.2066 91.8403 66.2066 92.2219C66.2066 92.528 66.3323 92.7876 66.5837 93.0008C66.8385 93.2105 67.2692 93.4031 67.8758 93.5785C68.4859 93.7538 68.9618 93.9481 69.3037 94.1613C69.6489 94.3711 69.9037 94.6169 70.0679 94.8989C70.2355 95.1808 70.3193 95.5127 70.3193 95.8943C70.3193 96.503 70.088 96.9912 69.6255 97.3592C69.1629 97.7237 68.5445 97.9059 67.7703 97.9059C67.2675 97.9059 66.7982 97.8079 66.3625 97.6119C65.9268 97.4125 65.5899 97.1408 65.3519 96.797C65.1173 96.4531 65 96.0628 65 95.6261H65.9703C65.9703 96.08 66.1329 96.4394 66.458 96.7041C66.7865 96.9655 67.2239 97.0961 67.7703 97.0961C68.2797 97.0961 68.6702 96.9895 68.9417 96.7763C69.2132 96.5631 69.349 96.2726 69.349 95.9047C69.349 95.5367 69.2233 95.253 68.9719 95.0536C68.7205 94.8507 68.2646 94.6513 67.6043 94.4553Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M75.1171 97.8028C75.0634 97.6927 75.0199 97.4967 74.9863 97.2148C74.554 97.6755 74.0378 97.9059 73.4378 97.9059C72.9015 97.9059 72.4608 97.7512 72.1155 97.4417C71.7736 97.1288 71.6027 96.7334 71.6027 96.2554C71.6027 95.6743 71.8172 95.2238 72.2462 94.904C72.6786 94.5808 73.2853 94.4192 74.0663 94.4192H74.9713V93.9808C74.9713 93.6472 74.8741 93.3825 74.6797 93.1865C74.4852 92.987 74.1987 92.8873 73.8199 92.8873C73.4881 92.8873 73.2099 92.9733 72.9853 93.1452C72.7607 93.3171 72.6485 93.5252 72.6485 93.7693H71.7133C71.7133 93.4908 71.8088 93.2226 71.9999 92.9647C72.1943 92.7033 72.4557 92.497 72.7842 92.3457C73.116 92.1944 73.4797 92.1188 73.8752 92.1188C74.502 92.1188 74.993 92.2804 75.3483 92.6036C75.7036 92.9234 75.888 93.3653 75.9014 93.9292L75.9014 96.4978C75.9014 97.0102 75.9651 97.4176 76.0924 97.7202V97.8028H75.1171ZM73.5736 97.0755C73.8652 97.0755 74.1417 96.9981 74.4031 96.8434C74.6646 96.6887 74.8539 96.4875 74.9713 96.2399L74.9713 95.0949H74.2422C73.1026 95.0949 72.5328 95.437 72.5328 96.1213C72.5328 96.4204 72.63 96.6543 72.8244 96.8228C73.0188 96.9912 73.2685 97.0755 73.5736 97.0755Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4171 96.5081L80.7645 92.2219H81.7147L79.764 97.8028H79.0551L77.0842 92.2219H78.0345L79.4171 96.5081Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M83.9635 97.8028H83.0333V92.2219H83.9635V97.8028ZM82.9579 90.7416C82.9579 90.5869 83.0032 90.4562 83.0937 90.3496C83.1875 90.243 83.3249 90.1897 83.5059 90.1897C83.6869 90.1897 83.8244 90.243 83.9182 90.3496C84.0121 90.4562 84.059 90.5869 84.059 90.7416C84.059 90.8964 84.0121 91.0253 83.9182 91.1285C83.8244 91.2316 83.6869 91.2832 83.5059 91.2832C83.3249 91.2832 83.1875 91.2316 83.0937 91.1285C83.0032 91.0253 82.9579 90.8964 82.9579 90.7416Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M86.6797 92.2219L86.7099 92.9234C87.1255 92.387 87.6685 92.1188 88.3389 92.1188C89.4886 92.1188 90.0684 92.7842 90.0785 94.1149V97.8028H89.1483V94.1097C89.145 93.7074 89.0545 93.41 88.8768 93.2174C88.7026 93.0249 88.4294 92.9286 88.0573 92.9286C87.7557 92.9286 87.4909 93.0111 87.263 93.1761C87.035 93.3412 86.8574 93.5578 86.73 93.826V97.8028H85.7999V92.2219H86.6797Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6032 94.9659C91.6032 94.096 91.7993 93.4048 92.1914 92.8925C92.5836 92.3767 93.1031 92.1188 93.75 92.1188C94.4137 92.1188 94.9315 92.3595 95.3036 92.8409L95.3488 92.2219H96.1985V97.6686C96.1985 98.3907 95.989 98.9598 95.57 99.3759C95.1544 99.792 94.5947 100 93.8908 100C93.4986 100 93.1149 99.914 92.7395 99.7421C92.3641 99.5702 92.0775 99.3346 91.8797 99.0355L92.3624 98.463C92.7612 98.9684 93.2489 99.2212 93.8254 99.2212C94.2779 99.2212 94.6299 99.0905 94.8813 98.8292C95.136 98.5678 95.2634 98.1999 95.2634 97.7254V97.2457C94.8913 97.6858 94.3835 97.9059 93.74 97.9059C93.1031 97.9059 92.587 97.6429 92.1914 97.1168C91.7993 96.5907 91.6032 95.8737 91.6032 94.9659ZM92.5383 95.0742C92.5383 95.7035 92.664 96.1987 92.9154 96.5597C93.1668 96.9173 93.5188 97.0961 93.9712 97.0961C94.5578 97.0961 94.9885 96.8228 95.2634 96.276V93.728C94.9785 93.1951 94.5511 92.9286 93.9813 92.9286C93.5288 92.9286 93.1752 93.1091 92.9205 93.4701C92.6657 93.8312 92.5383 94.3659 92.5383 95.0742Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M101.117 96.3224C101.117 96.0646 101.021 95.8651 100.83 95.7241C100.643 95.5797 100.313 95.4559 99.8399 95.3528C99.3707 95.2496 98.9969 95.1258 98.7187 94.9814C98.4439 94.837 98.2394 94.6651 98.1053 94.4656C97.9746 94.2662 97.9093 94.0289 97.9093 93.7538C97.9093 93.2965 98.097 92.9097 98.4724 92.5933C98.8511 92.277 99.3338 92.1188 99.9203 92.1188C100.537 92.1188 101.036 92.2821 101.419 92.6088C101.804 92.9354 101.997 93.3532 101.997 93.8621H101.062C101.062 93.6008 100.953 93.3756 100.735 93.1865C100.52 92.9973 100.249 92.9028 99.9203 92.9028C99.5818 92.9028 99.317 92.9784 99.126 93.1297C98.9349 93.281 98.8394 93.4787 98.8394 93.7229C98.8394 93.9533 98.9282 94.1269 99.1059 94.2438C99.2835 94.3607 99.6036 94.4725 100.066 94.5791C100.532 94.6857 100.909 94.8129 101.197 94.9608C101.486 95.1086 101.698 95.2874 101.836 95.4972C101.977 95.7035 102.047 95.9562 102.047 96.2554C102.047 96.754 101.853 97.1546 101.464 97.4572C101.075 97.7563 100.571 97.9059 99.9505 97.9059C99.5148 97.9059 99.1293 97.8268 98.7941 97.6686C98.459 97.5105 98.1958 97.2904 98.0048 97.0084C97.8171 96.723 97.7232 96.4153 97.7232 96.0852H98.6534C98.6701 96.405 98.7941 96.6594 99.0254 96.8485C99.26 97.0342 99.5684 97.1271 99.9505 97.1271C100.302 97.1271 100.584 97.0549 100.795 96.9104C101.01 96.7626 101.117 96.5666 101.117 96.3224Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M109.129 93.0781C108.988 93.0541 108.835 93.042 108.671 93.042C108.061 93.042 107.647 93.3085 107.429 93.8415V97.8028H106.499V92.2219H107.404L107.419 92.8667C107.724 92.3681 108.157 92.1188 108.716 92.1188C108.897 92.1188 109.035 92.1429 109.129 92.191V93.0781Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M113.489 97.8028C113.435 97.6927 113.392 97.4967 113.358 97.2148C112.926 97.6755 112.41 97.9059 111.81 97.9059C111.274 97.9059 110.833 97.7512 110.488 97.4417C110.146 97.1288 109.975 96.7334 109.975 96.2554C109.975 95.6743 110.189 95.2238 110.618 94.904C111.051 94.5808 111.657 94.4192 112.438 94.4192H113.343V93.9808C113.343 93.6472 113.246 93.3825 113.052 93.1865C112.857 92.987 112.571 92.8873 112.192 92.8873C111.86 92.8873 111.582 92.9733 111.357 93.1452C111.133 93.3171 111.02 93.5252 111.02 93.7693H110.085C110.085 93.4908 110.181 93.2226 110.372 92.9647C110.566 92.7033 110.828 92.497 111.156 92.3457C111.488 92.1944 111.852 92.1188 112.247 92.1188C112.874 92.1188 113.365 92.2804 113.72 92.6036C114.076 92.9234 114.26 93.3653 114.273 93.9292V96.4978C114.273 97.0102 114.337 97.4176 114.464 97.7202V97.8028H113.489ZM111.946 97.0755C112.237 97.0755 112.514 96.9981 112.775 96.8434C113.037 96.6887 113.226 96.4875 113.343 96.2399V95.0949H112.614C111.475 95.0949 110.905 95.437 110.905 96.1213C110.905 96.4204 111.002 96.6543 111.196 96.8228C111.391 96.9912 111.641 97.0755 111.946 97.0755Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M117.337 90.8706V92.2219H118.352V92.9595H117.337V96.4204C117.337 96.644 117.382 96.8124 117.472 96.9259C117.563 97.0359 117.717 97.091 117.935 97.091C118.042 97.091 118.19 97.0703 118.377 97.0291V97.8028C118.133 97.8715 117.895 97.9059 117.663 97.9059C117.248 97.9059 116.934 97.777 116.723 97.5191C116.512 97.2612 116.406 96.895 116.406 96.4204V92.9595H115.416V92.2219H116.406V90.8706H117.337Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M122.044 97.9059C121.306 97.9059 120.707 97.6583 120.244 97.1632C119.781 96.6646 119.55 95.9992 119.55 95.1671V94.9917C119.55 94.4381 119.652 93.9447 119.857 93.5114C120.065 93.0747 120.353 92.7343 120.722 92.4902C121.094 92.2426 121.496 92.1188 121.928 92.1188C122.635 92.1188 123.185 92.3578 123.577 92.8357C123.969 93.3137 124.166 93.998 124.166 94.8886V95.2857H120.48C120.494 95.8359 120.65 96.2812 120.948 96.6216C121.249 96.9586 121.632 97.1271 122.094 97.1271C122.423 97.1271 122.701 97.0583 122.929 96.9208C123.157 96.7832 123.356 96.601 123.527 96.374L124.095 96.8279C123.639 97.5466 122.956 97.9059 122.044 97.9059ZM121.928 92.9028C121.553 92.9028 121.238 93.0438 120.983 93.3257C120.728 93.6043 120.571 93.9962 120.51 94.5017H123.235V94.4295C123.209 93.9447 123.081 93.5699 122.853 93.3051C122.625 93.0369 122.317 92.9028 121.928 92.9028Z",
    fill: "black",
    fillOpacity: 0.54
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 133.688 346.676)",
    fill: "#B4B2B2"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 133.688 346.676)",
    fill: "#B4B2B2"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    width: 3.67634,
    height: 31.4027,
    rx: 1.83817,
    transform: "matrix(-4.37114e-08 -1 -1 4.37114e-08 133.688 346.676)",
    fill: "#B4B2B2"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M136.95 91.75H138.05V92.85H136.95V91.75ZM136.95 93.95H138.05V97.25H136.95V93.95ZM137.5 89C134.464 89 132 91.464 132 94.5C132 97.536 134.464 100 137.5 100C140.536 100 143 97.536 143 94.5C143 91.464 140.536 89 137.5 89ZM137.5 98.9C135.075 98.9 133.1 96.9255 133.1 94.5C133.1 92.0745 135.075 90.1 137.5 90.1C139.926 90.1 141.9 92.0745 141.9 94.5C141.9 96.9255 139.926 98.9 137.5 98.9Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M346.95 90.75H348.05V91.85H346.95V90.75ZM346.95 92.95H348.05V96.25H346.95V92.95ZM347.5 88C344.464 88 342 90.464 342 93.5C342 96.536 344.464 99 347.5 99C350.536 99 353 96.536 353 93.5C353 90.464 350.536 88 347.5 88ZM347.5 97.9C345.075 97.9 343.1 95.9255 343.1 93.5C343.1 91.0745 345.075 89.1 347.5 89.1C349.926 89.1 351.9 91.0745 351.9 93.5C351.9 95.9255 349.926 97.9 347.5 97.9Z",
    fill: "black",
    fillOpacity: 0.54
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0781 63.0117H90.4355C91.2884 62.9987 91.959 62.7741 92.4473 62.3379C92.9355 61.9017 93.1797 61.3125 93.1797 60.5703C93.1797 58.9036 92.3496 58.0703 90.6895 58.0703C89.9082 58.0703 89.2832 58.2949 88.8145 58.7441C88.3522 59.1868 88.1211 59.776 88.1211 60.5117H86.3145C86.3145 59.3854 86.7246 58.4512 87.5449 57.709C88.3717 56.9603 89.4199 56.5859 90.6895 56.5859C92.0306 56.5859 93.082 56.9408 93.8438 57.6504C94.6055 58.36 94.9863 59.3464 94.9863 60.6094C94.9863 61.2279 94.7845 61.8268 94.3809 62.4062C93.9837 62.9857 93.4401 63.4186 92.75 63.7051C93.5312 63.9525 94.1335 64.3626 94.5566 64.9355C94.9863 65.5085 95.2012 66.2083 95.2012 67.0352C95.2012 68.3112 94.7845 69.3236 93.9512 70.0723C93.1178 70.821 92.0339 71.1953 90.6992 71.1953C89.3646 71.1953 88.2773 70.834 87.4375 70.1113C86.6042 69.3887 86.1875 68.4349 86.1875 67.25H88.0039C88.0039 67.9987 88.248 68.5977 88.7363 69.0469C89.2246 69.4961 89.8789 69.7207 90.6992 69.7207C91.5716 69.7207 92.2389 69.4928 92.7012 69.0371C93.1634 68.5814 93.3945 67.9271 93.3945 67.0742C93.3945 66.2474 93.1406 65.6126 92.6328 65.1699C92.125 64.7272 91.3926 64.4993 90.4355 64.4863H89.0781V63.0117ZM104.605 64.75C104.228 65.1992 103.775 65.5605 103.248 65.834C102.727 66.1074 102.154 66.2441 101.529 66.2441C100.709 66.2441 99.9928 66.0423 99.3809 65.6387C98.7754 65.235 98.3066 64.6686 97.9746 63.9395C97.6426 63.2038 97.4766 62.3932 97.4766 61.5078C97.4766 60.5573 97.6556 59.7012 98.0137 58.9395C98.3783 58.1777 98.8926 57.5951 99.5566 57.1914C100.221 56.7878 100.995 56.5859 101.881 56.5859C103.287 56.5859 104.394 57.1133 105.201 58.168C106.015 59.2161 106.422 60.6484 106.422 62.4648V62.9922C106.422 65.7591 105.875 67.7806 104.781 69.0566C103.688 70.3262 102.037 70.9772 99.8301 71.0098H99.4785V69.4863H99.8594C101.35 69.4603 102.496 69.0729 103.297 68.3242C104.098 67.569 104.534 66.3776 104.605 64.75ZM101.822 64.75C102.428 64.75 102.984 64.5645 103.492 64.1934C104.007 63.8223 104.381 63.3633 104.615 62.8164V62.0938C104.615 60.9089 104.358 59.9453 103.844 59.2031C103.329 58.4609 102.678 58.0898 101.891 58.0898C101.096 58.0898 100.458 58.3958 99.9766 59.0078C99.4948 59.6133 99.2539 60.4141 99.2539 61.4102C99.2539 62.3802 99.485 63.181 99.9473 63.8125C100.416 64.4375 101.041 64.75 101.822 64.75Z",
    fill: "black",
    fillOpacity: 0.87
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M5 10C5 4.47715 9.47716 2.32358e-08 15 5.18986e-08L571 2.93746e-06C576.523 2.96612e-06 581 4.47715 581 10L581 16L5 16L5 10Z",
    fill: "#ACAAD6"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7953 10.5533C17.1445 10.5533 18.2383 9.45791 18.2383 8.10672C18.2383 6.75552 17.1445 5.66016 15.7953 5.66016C14.446 5.66016 13.3522 6.75552 13.3522 8.10672C13.3522 9.45791 14.446 10.5533 15.7953 10.5533Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0683 10.5533C26.4176 10.5533 27.5114 9.45791 27.5114 8.10672C27.5114 6.75552 26.4176 5.66016 25.0683 5.66016C23.719 5.66016 22.6252 6.75552 22.6252 8.10672C22.6252 9.45791 23.719 10.5533 25.0683 10.5533Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M34.342 10.5533C35.6913 10.5533 36.7851 9.45791 36.7851 8.10672C36.7851 6.75552 35.6913 5.66016 34.342 5.66016C32.9927 5.66016 31.8989 6.75552 31.8989 8.10672C31.8989 9.45791 32.9927 10.5533 34.342 10.5533Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_817_4938",
    x: 0,
    y: 0,
    width: 586,
    height: 386,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_817_4938"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_817_4938",
    result: "shape"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDefaultPreview);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/default-preview.1c42bf70064dddaf7db4fe00097d679c.svg";